import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Icon } from 'LocalGluons';
import { Icon as RNVIcon } from 'renative';
import Theme from 'Theme';
import { APP_METADATA } from '../../../options';

const styles = StyleSheet.create({
    text: {
        color: Theme.primaryTextColor,
        fontSize: 12
    },
    link: {
        color: Theme.primaryTextColor,
        marginHorizontal: 10,
        fontSize: 12
    }
});

const Footer = () => (
    <View
        style={{
            height: 200,
            backgroundColor: Theme.secondaryButtonBackgroundColor,
            padding: 20,
            paddingHorizontal: 40,
            marginTop: 'auto'
        }}
    >
        <View
            style={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                paddingBottom: 20,
                borderBottomWidth: 1,
                borderBottomColor: 'black'
            }}
        >
            <a
                data-testid="facebook"
                style={{ textDecoration: 'none' }}
                href={APP_METADATA.facebookUrl}
            >
                <RNVIcon
                    iconFont="fontAwesome"
                    iconName="facebook"
                    iconColor={Theme.primaryTextColor}
                    style={{ width: 25, marginHorizontal: 10 }}
                />
            </a>
            <a
                data-testid="twitter"
                style={{ textDecoration: 'none' }}
                href={APP_METADATA.twitterUrl}
            >
                <RNVIcon
                    iconFont="fontAwesome"
                    iconName="twitter"
                    iconColor={Theme.primaryTextColor}
                    style={{ width: 25, marginHorizontal: 10 }}
                />
            </a>
        </View>

        <View style={{ flexDirection: 'row', paddingTop: 10 }}>
            <View style={{ width: 150, justifyContent: 'center' }}>
                <Icon name="logo" style={{ width: 50, height: 50 }} />
            </View>
            <View
                style={{
                    flex: 1,
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <a
                    data-testid="impressum"
                    style={{ textDecoration: 'none' }}
                    href={APP_METADATA.impressumUrl}
                >
                    <Text style={styles.link}>Impressum</Text>
                </a>
                <a
                    data-testid="contact"
                    style={{ textDecoration: 'none' }}
                    href={APP_METADATA.contactUrl}
                >
                    <Text style={styles.link}>Contact</Text>
                </a>
                <a
                    data-testid="terms"
                    style={{ textDecoration: 'none' }}
                    href={APP_METADATA.termsUrl}
                >
                    <Text style={styles.link}>Terms</Text>
                </a>
            </View>
            <View style={{ width: 150, justifyContent: 'center', alignItems: 'flex-end' }}>
                <Text style={styles.text}>{`© ${new Date().getFullYear()} ${
                    APP_METADATA.vendorName
                }`}</Text>
            </View>
        </View>
    </View>
);

export default Footer;
